import React, { useEffect, useState } from 'react';

const Marker = (options) => {

    const [marker, setMarker] = useState();

    useEffect(() => {
        if (!marker && window.google) {
            setMarker(new window.google.maps.Marker());
        }

        // remove marker from map on unmount
        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);

    useEffect(() => {
        if (marker && window.google) {
            marker.setOptions(options);
        }
    }, [marker, options]);
    return null;
};

export default Marker;